import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { getDefaultRoute } from '@/utils/routes'

function redirectToDefaultRoute(to: RouteLocationNormalized, next: NavigationGuardNext) {
  const redirect = to.path === '/'
  const route = getDefaultRoute()
  if (redirect && route !== '/') next({ name: route })
  else next()
}

/** Base app shell route (children are merged in from other modules in router/index.ts) */
export const baseRoute: RouteRecordRaw = {
  path: '/',
  component: () => import('@/modules/core/views/AppBase.view.vue'),
  beforeEnter: (_to, _from, next) => redirectToDefaultRoute(_to, next),
  children: []
}

export const notFoundRoute: RouteRecordRaw = {
  path: '/404',
  name: ROUTES.NOT_FOUND,
  component: () => import('@/modules/core/views/NotFound.view.vue')
}

export const catchAllRoute: RouteRecordRaw = {
  path: '/:pathMatch(.*)*',
  redirect: '/404'
}
